export const compareMobileGames: Record<string, string> = {
  mobile_dau: 'CompareMobileGamesActiveUsersDownloadButton',
  mobile_revenue: 'CompareMobileGamesRevenueDownloadButton',
  mobile_download: 'CompareMobileGamesDownloadsDownloadButton',
  mobile_storeRank: 'CompareMobileGamesStoreRankDownloadButton',
};

export const following: Record<string, string> = {
  mobile_current: 'FollowingMobileGamesCurrentGamesDownloadButton',
  pc_current: 'FollowingPCGamesCurrentGamesDownloadButton',
  console_current: 'FollowingConsoleGamesCurrentGamesDownloadButton',
  company_current: 'FollowingCompaniesDownloadButton',
  mobile_new: 'FollowingMobileGamesNewReleaseAndUpcomingGamesDownloadButton',
  pc_new: 'FollowingPCGamesNewReleaseAndUpcomingGamesDownloadButton',
  console_new: 'FollowingConsoleGamesNewReleaseAndUpcomingGamesDownloadButton',
};

export const genreProfile: Record<string, string> = {
  mobile_main: 'GenreProfileMobileGamesMainGenreDownloadButton',
  mobile_sub: 'GenreProfileMobileGamesSubGenreDownloadButton',
  // 之前所有的打点都在genreProfileDownloadExcel上，为了能查到旧的打点，因此沿用，造成风格不一致
  // 目前修改时间是25年12月20日，在发版前genre profile所有的打点记录都会算在mobile的mainsub
  mobile_mainsub: 'genreProfileDownloadExcel',
  pc_main: 'GenreProfilePCGamesMainGenreDownloadButton',
  pc_sub: 'GenreProfilePCGamesSubGenreDownloadButton',
  pc_mainsub: 'GenreProfilePCGamesMainsubGenreDownloadButton',
  console_main: 'GenreProfileConsoleGamesMainGenreDownloadButton',
  console_sub: 'GenreProfileConsoleGamesSubGenreDownloadButton',
  console_mainsub: 'GenreProfileConsoleGamesMainsubGenreDownloadButton',
  total_main: 'GenreProfileTotalGamesMainGenreDownloadButton',
  total_sub: 'GenreProfileTotalGamesSubGenreDownloadButton',
  total_mainsub: 'GenreProfileTotalGamesMainsubGenreDownloadButton',
};

export const genreProfileStats: Record<string, string> = {
  // 大概意思同genreProfile的mobile_mainsub
  mobile_operation: 'genreProfileDetailStatsDownloadExcel',
  mobile_games: 'GenreProfileStatsMobileGamesByGamesDownloadButton',
  mobile_countries: 'GenreProfileStatsMobileGamesByCountriesDownloadButton',
  mobile_companies: 'GenreProfileStatsMobileGamesByCompaniesDownloadButton',
  pc_operation: 'GenreProfileStatsPCGamesOperationDataDownloadButton',
  pc_games: 'GenreProfileStatsPCGamesByGamesDownloadButton',
  pc_countries: 'GenreProfileStatsPCGamesByCountriesDownloadButton',
  pc_companies: 'GenreProfileStatsPCGamesByCompaniesDownloadButton',
  console_operation: 'GenreProfileStatsConsoleGamesOperationDataDownloadButton',
  console_games: 'GenreProfileStatsConsoleGamesByGamesDownloadButton',
  console_countries: 'GenreProfileStatsConsoleGamesByCountriesDownloadButton',
  console_companies: 'GenreProfileStatsConsoleGamesByCompaniesDownloadButton',
};

export const marketProfile: Record<string, string> = {
  mobile: 'MarketProfileMobileGamesDownloadButton',
  pc: 'MarketProfilePCGamesDownloadButton',
  console: 'MarketProfileConsoleGamesDownloadButton',
};

export const marketProfileStats: Record<string, string> = {
  mobile_operation: 'MarketProfileStatsMobileOperationDataDownloadButton',
  mobile_games: 'MarketProfileStatsMobileByGamesDownloadButton',
  mobile_genres: 'MarketProfileStatsMobileByGenresDownloadButton',
  mobile_companies: 'MarketProfileStatsMobileByCompaniesDownloadButton',
  pc_operation: 'MarketProfileStatsPCOperationDataDownloadButton',
  // 注意这里和手游是不一样的页面，所以game/genre/companies命名上有一些区别
  pc_game: 'MarketProfileStatsPCByGamesDownloadButton',
  pc_genre: 'MarketProfileStatsPCByGenresDownloadButton',
  pc_company: 'MarketProfileStatsPCByCompaniesDownloadButton',
  console_operation: 'MarketProfileStatsConsoleOperationDataDownloadButton',
  console_game: 'MarketProfileStatsConsoleByGamesDownloadButton',
  console_genre: 'MarketProfileStatsConsoleByGenresDownloadButton',
  console_company: 'MarketProfileStatsConsoleByCompaniesDownloadButton',
};

export const potential: Record<string, string> = {
  mobile_newRelease: 'PotentialNewReleaseGamesMobileGamesDownloadButton',
  pc_newRelease: 'PotentialNewReleaseGamesPCGamesDownloadButton',
  console_newRelease: 'PotentialNewReleaseGamesConsoleGamesDownloadButton',
  mobile_upcoming: 'PotentialUpcomingGamesMobileGamesDownloadButton',
  pc_upcoming: 'PotentialUpcomingGamesPCGamesDownloadButton',
  console_upcoming: 'PotentialUpcomingGamesConsoleGamesDownloadButton',
};

export const companiesStats:Record<string, string> = {
  mobile_revenue: 'TopChartsCompaniesGamesAndStatsMobileRevenueDownloadButton',
  mobile_download: 'TopChartsCompaniesGamesAndStatsMobileDownloadsDownloadButton',
  pc_digitalRevenue: 'TopChartsCompaniesGamesAndStatsPCDigitalRevenueDownloadButton',
  pc_physicalRevenue: 'TopChartsCompaniesGamesAndStatsPCPhysicalRevenueDownloadButton',
  pc_pcu: 'TopChartsCompaniesGamesAndStatsPCPCUDownloadButton',
  pc_mau: 'TopChartsCompaniesGamesAndStatsPCMAUDownloadButton',
  console_digitalRevenue: 'TopChartsCompaniesGamesAndStatsConsoleDigitalRevenueDownloadButton',
  console_physicalRevenue: 'TopChartsCompaniesGamesAndStatsConsolePhysicalRevenueDownloadButton',
  console_mau: 'TopChartsCompaniesGamesAndStatsConsoleMAUDownloadButton',
  mobile_gamesOwned: 'TopChartsCompaniesGamesAndStatsGamesOwnedDownloadButton',
};

export const mobileStats:Record<string, string> = {
  stats_activeusers: 'TopChartsMobileGamesStatsActiveUsersDownloadButton',
  stats_revenue: 'TopChartsMobileGamesStatsRevenueDownloadButton',
  stats_downloads: 'TopChartsMobileGamesStatsDownloadsDownloadButton',
  'stats_retention—retention_lifetime': 'TopChartsMobileGamesStatsLifetimeRetentionDownloadButton',
  'stats_retention—retention_monthly_sensortower': 'TopChartsMobileGamesStatsMonthlyRetentionDownloadButton',
  'stats_retention—retention_monthly': 'TopChartsMobileGamesStatsMonthlyRetentionDownloadButton',
  stats_rpd: 'TopChartsMobileGamesStatsRPDDownloadButton',
  countries_activeusers: 'TopChartsMobileGamesCountriesActiveUsersDownloadButton',
  countries_revenue: 'TopChartsMobileGamesCountriesRevenueDownloadButton',
  countries_downloads: 'TopChartsMobileGamesCountriesDownloadsDownloadButton',
  'countries_retention—retention_lifetime': 'TopChartsMobileGamesStatsLifetimeRetentionDownloadButton',
  'countries_retention—retention_monthly_sensortower': 'TopChartsMobileGamesStatsMonthlyRetentionDownloadButton',
  'countries_retention—retention_monthly': 'TopChartsMobileGamesStatsMonthlyRetentionDownloadButton',
  countries_rpd: 'TopChartsMobileGamesStatsRPDDownloadButton',
};

export const pcconsoleStats:Record<string, string> = {
  'pc_stats_pcu': 'TopChartsPCGamesStatsPCUDownloadButton',
  'pc_stats_digitalRevenue': 'TopChartsPCGamesStatsDigitalRevenueDownloadButton',
  'pc_stats_gsd': 'TopChartsPCGamesStatsGSDSaleDataDownloadButton',
  'pc_stats_physicalRevenue': 'TopChartsPCGamesStatsPhysicalRevenueDownloadButton',
  'pc_stats_newzooMetrics': 'TopChartsPCGamesStatsNewzooMetricsDownloadButton',
  'pc_stats_steamSales—est_revenue': 'TopChartsPCGamesStatsSteamSalesDownloadButton',
  'pc_countries_pcu': 'TopChartsPCGamesCountriesPCUDownloadButton',
  'pc_countries_digitalRevenue': 'TopChartsPCGamesCountriesDigitalRevenueDownloadButton',
  'pc_countries_gsd': 'TopChartsPCGamesCountriesGSDSaleDataDownloadButton',
  'pc_countries_physicalRevenue': 'TopChartsPCGamesCountriesPhysicalRevenueDownloadButton',
  'pc_countries_newzooMetrics': 'TopChartsPCGamesCountriesNewzooMetricsDownloadButton',
  'pc_countries_steamSales—est_revenue': 'TopChartsPCGamesCountriesSteamSalesDownloadButton',
  'console_stats_digitalRevenue': 'TopChartsConsoleGamesStatsDigitalRevenueDownloadButton',
  'console_stats_gsd': 'TopChartsConsoleGamesStatsGSDSaleDataDownloadButton',
  'console_stats_physicalRevenue': 'TopChartsConsoleGamesStatsPhysicalRevenueDownloadButton',
  'console_stats_japanSales': 'TopChartsConsoleGamesStatsJapanSalesDownloadButton',
  'console_stats_newzooMetrics': 'TopChartsConsoleGamesStatsNewzooMetricsDownloadButton',
  'console_countries_digitalRevenue': 'TopChartsConsoleGamesCountriesDigitalRevenueDownloadButton',
  'console_countries_gsd': 'TopChartsConsoleGamesCountriesGSDSaleDataDownloadButton',
  'console_countries_physicalRevenue': 'TopChartsConsoleGamesCountriesPhysicalRevenueDownloadButton',
  'console_countries_japanSales': 'TopChartsConsoleGamesCountriesJapanSalesDownloadButton',
  'console_countries_newzooMetrics': 'TopChartsConsoleGamesCountriesNewzooMetricsDownloadButton',
  'combine_stats_allMetrics': 'TopChartsPCAndConsoleGamesStatsAllMetricsDownloadButton',
  'combine_stats_digitalRevenue': 'TopChartsPCAndConsoleGamesStatsDigitalRevenueDownloadButton',
  'combine_stats_gsd': 'TopChartsPCAndConsoleGamesStatsGSDSaleDataDownloadButton',
  // 这里页面传值是错的，steamData用的pcu
  'combine_stats_pcu': 'TopChartsPCAndConsoleGamesStatsSteamDataDownloadButton',
  'combine_stats_consoleData': 'TopChartsPCAndConsoleGamesStatsConsoleDataDownloadButton',
  'combine_countries_consoleData': 'TopChartsPCAndConsoleGamesCountriesConsoleDataDownloadButton',
  'combine_stats_physicalRevenue': 'TopChartsPCAndConsoleGamesStatsPhysicalRevenueDownloadButton',
  'combine_stats_japanSales': 'TopChartsPCAndConsoleGamesStatsJapanSalesDownloadButton',
  'combine_stats_newzooMetrics': 'TopChartsPCAndConsoleGamesStatsNewzooMetricsDownloadButton',
  // 以下注释是下载没启用
  // 'combine_countries_digitalRevenue': 'TopChartsPCAndConsoleGamesCountriesDigitalRevenueDownloadButton',
  // 'combine_countries_gsd': 'TopChartsPCAndConsoleGamesCountriesGSDSaleDataDownloadButton',
  // 'combine_countries_pcu': 'TopChartsPCAndConsoleGamesCountriesSteamDataDownloadButton',
  // 'combine_countries_ampere': 'TopChartsPCAndConsoleGamesCountriesUserEngagementDownloadButton',
  // 'combine_countries_physicalRevenue': 'TopChartsPCAndConsoleGamesCountriesPhysicalRevenueDownloadButton',
  // 'combine_countries_newzooMetrics—mau': 'TopChartsPCAndConsoleGamesCountriesNewzooMetricsDownloadButton',
};

export const pcConsoleTopChart:Record<string, string> = {
  pc_PCU: 'TopChartsPCGamesPCUDownloadButton',
  pc_DigitalRevenue: 'TopChartsPCGamesDigitalRevenueDownloadButton',
  pc_PhysicalRevenue: 'TopChartsPCGamesPhysicalRevenueDownloadButton',
  pc_SteamSales: 'TopChartsPCGamesSteamSalesDownloadButton',
  pc_MAU: 'TopChartsPCGamesMAUDownloadButton',
  pc_LifeTimePlayers: 'TopChartsPCGamesLifetimePlayersDownloadButton',
  console_DigitalRevenue: 'TopChartsConsoleGamesDigitalRevenueDownloadButton',
  console_PhysicalRevenue: 'TopChartsConsoleGamesPhysicalRevenueDownloadButton',
  console_MAU: 'TopChartsConsoleGamesMAUDownloadButton',
  console_LifeTimePlayers: 'TopChartsConsoleGamesLifetimePlayersDownloadButton',
};

export const pcConsoleDetailOverlap:Record<string, string> = {
  pc: 'TopChartsPCGamesOverlapDownloadButton',
  // console没有overlap
  console: '',
  combine: 'TopChartsPCAndConsoleGamesSteamOverlapDownloadButton',
};
